import {Link} from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';

const Marker = ({markerInfo, $hover}) => {
  const marker = (
    <Link to={markerInfo.listingLink}>
      {markerInfo.mapMarker && $hover ? markerInfo.mapMarker : <img src="/img/marker.png" alt="no-price-marker"/>}
    </Link>
  );
  return markerInfo.showPrice && $hover ? (
    <div className="map-marker">
      <div className="arrow-up"></div>
      <div className="point">
        {marker}
      </div>
    </div>
  ) : <div className="no-price-marker">{marker}</div>;
};

Marker.propTypes = {
  $hover: PropTypes.bool,
  markerInfo: PropTypes.object.isRequired
}

export default Marker;



// WEBPACK FOOTER //
// ./src/components/solds/sold-map/marker.js